(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("SavingsGoalCalculator", [], factory);
	else if(typeof exports === 'object')
		exports["SavingsGoalCalculator"] = factory();
	else
		root["SavingsGoalCalculator"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition